import React, { ReactElement, useMemo, useEffect } from "react";
import {
    QualityHubTaskListViewRouteParams,
    QualityHubTaskListViewStateProps,
} from "./QualityHubTaskListView.types";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router";
import SpintrLoader from "src/ui/components/Loader";
import { getCancelTokenSource } from "src/api";
import { findTaskList } from "src/redux";
import { QualityHubTasksList } from "src/components";
import { SpintrTypes } from "src/typings";

/**
 * QualityHubTaskListView component
 *
 * @param {QualityHubTaskListViewProps} props - The component props
 * @returns {ReactElement | null} The rendered component
 */
function QualityHubTaskListView(): ReactElement | null {
    const params = useParams<QualityHubTaskListViewRouteParams>();
    const listId = useMemo(() => parseInt(params.listId, 10), [params.listId]);

    const dispatch = useDispatch();
    const {
        isLoading,
        taskList,
    } = useSelector<Spintr.AppState, QualityHubTaskListViewStateProps>(
        (appState) => ({
            isLoading: appState.qualityHub.listsLoading[listId] ?? false,
            taskList: appState.qualityHub.listsById[listId],
        }));

    useEffect(function _QualityHubTaskListViewMount() {
        if (!listId || isNaN(listId)) {
            return;
        }

        const cancelTokenSource = getCancelTokenSource();
        dispatch(findTaskList(listId, cancelTokenSource.token));

        return function _QualityHubTaskListViewUnmount() {
            cancelTokenSource.cancel();
        };
    }, [listId]);

    if (isLoading || !taskList) {
        return <SpintrLoader />;
    }

    return (
        <div id="QualityHubTaskListView">
            <QualityHubTasksList listId={listId}
                                 listMode={SpintrTypes.QualityHubTasksListMode.Creation} />
        </div>
    );
}

export default QualityHubTaskListView;

